/**
 * Funds Index Page Route
 *
 * Redirects to the explore page where users can browse funds.
 *
 * Route: /funds
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/funds/")({
  beforeLoad: () => {
    // Redirect /funds to /explore
    throw redirect({ to: "/explore" });
  },
  component: () => null,
});
